<template><div><h1 id="prerequisites" tabindex="-1"><a class="header-anchor" href="#prerequisites"><span>Prerequisites</span></a></h1>
<div class="hint-container warning">
<p class="hint-container-title">Warning</p>
<p>Before getting started, it is important to know that this isn't a simple, one-click process. You must be able to read and understand the documentation in order to successfully modify your device. There is a risk of bricking your device, losing data, etc. YOU ARE RESPONSIBLE FOR YOUR OWN DEVICE!</p>
</div>
<ul>
<li>A Chrome device you own (managed devices are unable to be modified)</li>
<li>Some form of external storage, such as a USB flash drive or SD Card</li>
<li>Some technical skills (installing an os, troubleshooting issues, etc)</li>
<li>Patience</li>
<li>Ideally, another computer to save yourself if something goes wrong</li>
<li>Your device's HWID</li>
</ul>
<p>The device's HWID, often referred to as the board name, is used to identify your device and determine whether or not it is supported. Avoid using marketing names to identify your device, such as &quot;HP Chromebook 14A&quot;, as they will usually lead to confusion since OEMs like to recycle the same name between many different devices.</p>
<p>To find your HWID, either boot into <a href="https://docs.mrchromebox.tech/docs/boot-modes/recovery.html" target="_blank" rel="noopener noreferrer">recovery mode</a> and look at the bottom of the screen, where it says MODEL, or open <code v-pre>chrome://system</code> in Chrome and search for <code v-pre>HWID</code>.</p>
<div class="hint-container tip">
<p class="hint-container-title">Tips</p>
<p>Most of the HWID can be ignored. For example, the most important part is <code v-pre>CAVE</code> in <code v-pre>CAVE D25-A4B-E4E-33C</code> and <code v-pre>HAYATO</code> in <code v-pre>HAYATO-YLRO C6B-C2C-F4F-V9P-G2I-A9Q</code>.</p>
</div>
</div></template>


